import { render, staticRenderFns } from "./knowledge-head.vue?vue&type=template&id=6d6680d4&scoped=true"
import script from "./knowledge-head.vue?vue&type=script&lang=js"
export * from "./knowledge-head.vue?vue&type=script&lang=js"
import style0 from "./knowledge-head.vue?vue&type=style&index=0&id=6d6680d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6680d4",
  null
  
)

export default component.exports